import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const NotFoundPage = () => (
  <main data-testid="notfound-page" className="bg-maternnia-porcelana/40 min-h-[70vh] flex items-center">
    <Seo title="Página não encontrada" path="/404" noindex />
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <p className="font-serif text-6xl text-maternnia-pink font-medium">404</p>
      <h1 className="mt-4 font-serif text-3xl md:text-4xl text-maternnia-charcoal font-medium">
        Não encontramos esta página
      </h1>
      <p className="mt-4 text-maternnia-taupe font-light leading-relaxed">
        O link pode estar incorreto ou o conteúdo pode ter mudado de lugar. Volte ao início para continuar a sua jornada.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 bg-maternnia-eucalipto text-white hover:bg-maternnia-floresta rounded-full px-6 py-3 text-sm font-medium transition">
          <Home size={16} /> Voltar ao início
        </Link>
        <Link to="/conteudos" className="inline-flex items-center gap-2 border border-maternnia-nevoa text-maternnia-charcoal hover:bg-white rounded-full px-6 py-3 text-sm font-medium transition">
          Ver conteúdos <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </main>
);

export default NotFoundPage;
